import { useQuery } from "@tanstack/react-query";
import { getActivityLocationsUrl } from "../helpers/getActivityLocationsUrl";
import { INTERVAL } from "@coworker/app/src/constants/clientTime";
import { httpClient } from "@coworker/http-client";

export const useActivityLocations = (
  taskType: string = "all",
  addonLocationType: string,
  enabled = true
) => {
  return useQuery<string[]>({
    queryKey: ["locations", taskType, addonLocationType],
    queryFn: async () => {
      const url = `/v1/${getActivityLocationsUrl(taskType, addonLocationType)}`;
      const result = await httpClient.tasks.get<{ data: string[] }>(url);
      return result.data;
    },
    staleTime: INTERVAL.MINUTE,
    enabled,
  });
};
